module.exports = __webpack_public_path__ + "img/33-CloudPOS.6160f752.jpg";